import { useTranslation } from 'react-i18next';
import { Tabs } from '@reverse-hr/design-system';
import {
  HOMEPAGE_TAB_KEY_LIST,
  HOMEPAGE_TABS_KEYS,
  HOMEPAGE_TABS_ROUTES,
} from '@app/constants/homepage';
import { useNavigate, useParams } from 'react-router-dom';
import { useHomepageRouteMatch } from '@utils/hooks/use-homepage-route-match';

export const HomepageNavigation = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { customerId } = useParams();

  const { isHomepageJobsPage, isHomepageCandidatesPage } =
    useHomepageRouteMatch();

  const onTabClick = tabKey => {
    const isSelectedTabCandidates = tabKey === HOMEPAGE_TABS_KEYS.CANDIDATES;

    navigate(getTabTargetPath({ customerId, isSelectedTabCandidates }));
  };

  return (
    <div className="c-homepage-navigation">
      <Tabs className="c-homepage-navigation__tabs">
        {HOMEPAGE_TAB_KEY_LIST.map(tabKey => (
          <Tabs.Item
            isSelected={
              tabKey === HOMEPAGE_TABS_KEYS.JOBS
                ? isHomepageJobsPage
                : isHomepageCandidatesPage
            }
            key={tabKey}
            onClick={() => onTabClick(tabKey)}
            title={t(`homepage.header.navigation.${tabKey}`)}
          />
        ))}
      </Tabs>
    </div>
  );
};

const getTabTargetPath = ({ customerId, isSelectedTabCandidates }) => {
  if (!customerId) {
    return isSelectedTabCandidates
      ? HOMEPAGE_TABS_ROUTES.CANDIDATES
      : HOMEPAGE_TABS_ROUTES.JOBS;
  }

  const customersPathSegment = `customers/${customerId}`;

  return isSelectedTabCandidates
    ? `/${customersPathSegment}${HOMEPAGE_TABS_ROUTES.CANDIDATES}`
    : `${HOMEPAGE_TABS_ROUTES.JOBS}${customersPathSegment}`;
};
